import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '@/components/Login';
import Dashboard from '@/components/Dashboard';
import AdminPanel from '@/components/AdminPanel';
import BonusesPenalties from '@/components/admin/BonusesPenalties';
import EmployeeReports from '@/components/admin/EmployeeReports';
import RefuelingPage from '@/components/RefuelingPage';
import DriverRefuelingPage from '@/components/DriverRefuelingPage';
import TripsPage from '@/components/TripsPage';
import MechanicPage from '@/components/MechanicPage';
import CalendarPage from '@/components/CalendarPage';
import TaskNotificationWidget from '@/components/TaskNotificationWidget';
import PWAInstallPrompt from '@/components/PWAInstallPrompt';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { ModulesProvider, useModules } from '@/contexts/ModulesContext';

function AppRoutes() {
  const { isAuthenticated, isAdmin, isDriver, isMechanic, mechanicAccess, loading } = useAuth();
  const { isModuleEnabled, loading: modulesLoading } = useModules();

  if (loading || modulesLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Загрузка...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            isAdmin ? (
              <Navigate to="/" replace />
            ) : isMechanic && mechanicAccess === 'mechanic_only' && !isDriver ? (
              <Navigate to="/mechanic" replace />
            ) : isDriver ? (
              <Navigate to="/refueling" replace />
            ) : (
              <Navigate to="/" replace />
            )
          ) : (
            <Login />
          )
        }
      />
      <Route
        path="/"
        element={
          isAuthenticated ? (
            isAdmin ? (
              <Dashboard />
            ) : isMechanic && mechanicAccess === 'mechanic_only' && !isDriver ? (
              <Navigate to="/mechanic" replace />
            ) : isDriver ? (
              <Navigate to="/refueling" replace />
            ) : (
              <Dashboard />
            )
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/fuel"
        element={
          isAuthenticated && isAdmin && isModuleEnabled('refueling') ? (
            <RefuelingPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/refueling"
        element={
          isAuthenticated && isDriver && isModuleEnabled('refueling') ? (
            <DriverRefuelingPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/admin"
        element={
          isAuthenticated && isAdmin ? (
            <AdminPanel />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/bonuses-penalties"
        element={
          isAuthenticated && isAdmin ? (
            <BonusesPenalties />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/employee-reports"
        element={
          isAuthenticated && isAdmin && isModuleEnabled('employee_reports') ? (
            <EmployeeReports />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/trips"
        element={
          isAuthenticated && isAdmin && isModuleEnabled('trips') ? (
            <TripsPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/mechanic"
        element={
          isAuthenticated && (isAdmin || isMechanic) && isModuleEnabled('mechanic') ? (
            <MechanicPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/calendar"
        element={
          isAuthenticated && isAdmin ? (
            <CalendarPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <ModulesProvider>
            <BrowserRouter>
              <AppRoutes />
              <TaskNotificationWidget />
            </BrowserRouter>
            <Toaster 
              position="top-center"
              expand={true}
              richColors
              duration={4000}
              closeButton
            />
            <PWAInstallPrompt />
          </ModulesProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
